import React, { useEffect, useState } from 'react';
import { Card, Spin, message } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import PermissionGuard from '../../components/PermissionGuard';
import { Modules } from '../../constants/permissions';
import { pw98m2Api, MenuItem } from '../../services/pw98m2Api';
import './PW98M2Form.css';

const PW98M2Form: React.FC = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState<MenuItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const resp = await pw98m2Api.getMenu();
        setItems(resp.items || []);
      } catch {
        message.error('載入選單失敗');
      } finally {
        setLoading(false);
      }
    };
    fetchMenu();
  }, []);

  return (
    <PermissionGuard module={Modules.PW98M2} action="query">
      <div className="pw98m2-container">
        <div className="pw98m2-header">
          <h2>人事資料核准沖銷</h2>
          <p style={{ color: '#666', marginTop: 4 }}>
            選擇要執行核准沖銷的人事單據類型
          </p>
        </div>
        {loading ? (
          <div style={{ textAlign: 'center', padding: 60 }}><Spin size="large" /></div>
        ) : (
          <div className="pw98m2-grid">
            {items.map(item => (
              <Card
                key={item.code}
                hoverable
                size="small"
                onClick={() => navigate(item.route)}
                style={{ cursor: 'pointer' }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: 14 }}>{item.label}</div>
                    <div style={{ color: '#888', fontSize: 12, marginTop: 4 }}>{item.desc}</div>
                  </div>
                  <RightOutlined style={{ color: '#bbb' }} />
                </div>
              </Card>
            ))}
          </div>
        )}
      </div>
    </PermissionGuard>
  );
};

export default PW98M2Form;
